// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-logs form .formgrid {\n  width: 100%;\n}", "",{"version":3,"sources":["webpack://./src/modules/HistoryLogs/history-logs.scss"],"names":[],"mappings":"AAII;EACE,WAAA;AAHN","sourcesContent":["@import '../../styles/theme';\n\n.history-logs {\n  form {\n    .formgrid {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
